import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { CustomButton, CustomInput, WhiteCard } from 'src/components';

import './reviewsForm.scss';
import { useDispatch, useSelector } from 'react-redux';
import { createReview, reviewsErrorsSelector, setReviewsErrors } from 'src/store/reviews';

export const ReviewsForm = () => {
  const { t } = useTranslation('reviews');

  const dispatch = useDispatch();

  const formErrors = useSelector(reviewsErrorsSelector);

  const [formData, setFormData] = useState({
    name: '',
    message: '',
  });

  const onSubmitForm = useCallback(
    (event) => {
      event.preventDefault();

      dispatch(createReview({ payload: formData, setFormData }));
    },
    [dispatch, formData],
  );

  const onChangeInput = useCallback(
    (key) => (event) => {
      setFormData((prev) => ({ ...prev, [key]: event.target.value }));

      const copiedErrors = _.cloneDeep(formErrors);

      delete copiedErrors[key];

      dispatch(setReviewsErrors(copiedErrors));
    },
    [dispatch, formErrors],
  );

  return (
    <div className="reviews-form">
      <WhiteCard>
        <div className="reviews-form__content">
          <h2>{t('leaveReview')}</h2>
          <h5>{t('yourOpinion')}</h5>
          <form className="reviews-form__main" onSubmit={onSubmitForm}>
            <div className="reviews-form__main__row">
              <CustomInput
                placeholder={t('userName')}
                value={formData?.name}
                onChange={onChangeInput('name')}
                errorMessage={formErrors?.name}
              />
            </div>
            <CustomInput
              type="text-area"
              placeholder={t('text')}
              value={formData?.message}
              onChange={onChangeInput('message')}
              errorMessage={formErrors?.message}
            />
            <div className="reviews-form__main__footer">
              {/* <div className="reviews-form__main__messages">
                {errorMessages?.map((item) => (
                  <FormMessage key={item.id} type={item.type} message={item.message} />
                ))}
              </div> */}
              <CustomButton title={t('send')} variant="filled" />
            </div>
          </form>
        </div>
      </WhiteCard>
    </div>
  );
};
